// extracted by mini-css-extract-plugin
module.exports = {"footer":"AppFooter_footer__3BUQe","social":"AppFooter_social__DbhAg","facebook":"AppFooter_facebook__3Jakk","youtube":"AppFooter_youtube__ilkRF"};